import React, { Component } from "react";
// import items from "./data";
import Client from "./Contentful";

// Setup the context api
const RoomContext = React.createContext();
// Now we have access to 2 components: Provider and Consumer
// Provider is allowing all the components in the tree to access it
// Consumer is used to access that information

class RoomProvider extends Component {
  state = {
    rooms: [],
    sortedRooms: [],
    featuredRooms: [],
    loading: true,
    type: "all",
    capacity: 1,
    price: 0,
    minPrice: 0,
    maxPrice: 0,
    minSize: 0,
    maxSize: 0,
    breakfast: false,
    pets: false,
  };

  // Get Data
  getData = async () => {
    try {
      let response = await Client.getEntries({
        content_type: "beachResortRoom",
        // order: "sys.createdAt",
        order: "-fields.price",
      });
      let rooms = this.formatData(response.items);
      let featuredRooms = rooms.filter((room) => room.featured === true);
      let maxPrice = Math.max(...rooms.map((room) => room.price));
      let maxSize = Math.max(...rooms.map((room) => room.size));
      this.setState({
        rooms,
        sortedRooms: rooms,
        featuredRooms,
        loading: false,
        maxPrice,
        maxSize,
        price: maxPrice,
      });
    } catch (error) {
      console.log(error);
    }
  };
  componentDidMount() {
    this.getData();
  }
  // Format data which come from the data.js or the contentful.
  formatData = (items) => {
    let tempItems = items.map((item) => {
      let id = item.sys.id;
      let images = item.fields.images.map((image) => image.fields.file.url);
      let room = { ...item.fields, images, id };
      return room;
    });
    // console.log(tempItems);
    return tempItems;
  };

  getRoom = (slug) => {
    let tempRooms = [...this.state.rooms];
    const room = tempRooms.find((item) => item.slug === slug);
    return room;
  };

  // Controlled forms.
  handleChange = (event) => {
    // target???
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = event.target.name;
    console.log(target.type);

    this.setState(
      {
        [name]: value,
      },
      this.filterRooms
    );
  };
  filterRooms = () => {
    let {
      rooms,
      type,
      capacity,
      price,
      // maxPrice,
      // minPrice,
      minSize,
      maxSize,
      breakfast,
      pets,
    } = this.state;
    // All the rooms
    let tempRooms = [...rooms];
    // filter by type
    if (type !== "all") {
      tempRooms = tempRooms.filter((room) => room.type === type);
    }
    // Transform capacity to number
    capacity = Number(capacity);
    // Filter by capacity
    if (capacity !== 1) {
      tempRooms = tempRooms.filter((room) => room.capacity >= capacity);
    }

    // filter by price
    price = Number(price);
    tempRooms = tempRooms.filter((room) => room.price <= price);

    // Filter by size
    tempRooms = tempRooms.filter(
      (room) => room.size >= minSize && room.size <= maxSize
    );

    // Filter by breakfast /pets
    if (breakfast) {
      tempRooms = tempRooms.filter((room) => room.breakfast === breakfast);
    }
    if (pets) {
      tempRooms = tempRooms.filter((room) => room.pets === pets);
    }
    // Change state
    this.setState({
      sortedRooms: tempRooms,
    });
  };
  render() {
    return (
      <RoomContext.Provider
        value={{
          ...this.state,
          getRoom: this.getRoom,
          handleChange: this.handleChange,
        }}>
        {this.props.children}
      </RoomContext.Provider>
    );
  }
}

const RoomConsumer = RoomContext.Consumer;

// Higher order component
export function WithRoomConsumer(Component) {
  return function ConsumerWrapper(props) {
    return (
      <RoomConsumer>
        {(value) => <Component {...props} context={value} />}
      </RoomConsumer>
    );
  };
}
export { RoomProvider, RoomConsumer, RoomContext };
